import { Box, Button, Grid, Typography } from "@mui/material";
//import { useForm } from "react-hook-form";

//import { FONT_PRIMARY } from "@/theme/typography";
import {
  //useGetDevicesQuery,
  useGetProductsQuery,
} from "@/redux-store/api/marketingApi";

// import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
// import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";
// import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import ProductCard from "@/components/Products/ProductCard";
import Section from "@/components/Section";
import SquareStackIcon from "@/assets/icons/solutions/square-stack.svg?react";
//import { getDevicesOptions } from "@/utils/forms/getDevicesOptions";
import { Link } from "react-router-dom";
import { ROUTES } from "@/utils/navigation";
import Notification from "@/components/Notification/Notification";
import { useState } from "react";

const VehicleTrackersSection = () => {
  const { data: products } = useGetProductsQuery({});
  //const { data: devices } = useGetDevicesQuery({});
  //const devicesOptions = getDevicesOptions(devices);
  const [notificationIsOpen, setNotificationIsOpen] = useState<boolean>(false);

  // const { control } = useForm<{ type_id: number | null }>({
  //   defaultValues: {
  //     type_id: null,
  //   },
  // });
  // const theme = useTheme();
  return (
    <Section pt={{ xs: 7.5, md: 2 }} pb={{ xs: 3.5, md: 8.5 }}>
      <Box
        sx={{
          marginBottom: "48px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h2">Vehicle Trackers</Typography>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
          }}
        >
          <Button
            component={Link}
            to={ROUTES.compareDevices}
            variant="text"
            startIcon={<SquareStackIcon />}
            sx={{ mr: 1 }}
          >
            View comparison table
          </Button>
          {/* <Box
            sx={{
              width: "130px",
              "& fieldset": { borderColor: "transparent" },
              "& .MuiSelect-select": { py: 1.5 },
            }}
          >
            {devicesOptions && (
              <DropdownInput
                name="type_id"
                control={control}
                placeholder="All devices"
                options={devicesOptions}
              />
            )}
          </Box> */}
        </Box>
      </Box>
      {products && (
        <Grid container spacing={4}>
          {products.map((product) => (
            <Grid item xs={12} sm={6} md={4} key={product.id}>
              <ProductCard product={product} />
            </Grid>
          ))}
          {/* <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                width: "auto",
                height: { xs: "241px", sm: "445px" },
                padding: "40px",
                borderRadius: "20px",
                boxSizing: "border-box",
                background:
                  "linear-gradient(131.9deg, #FF6B00 -0.3%, #FFAA6D 104.48%)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "start",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1.5rem", md: "2.5rem" },
                  fontFamily: FONT_PRIMARY,
                  color: theme.palette.common.white,
                  fontWeight: "700",
                }}
              >
                Enjoy 15% off on your first purchase.
              </Typography>
              <ButtonWithIcon
                sx={{
                  color: theme.palette.common.white,
                  path: {
                    fill: `${theme.palette.common.white}`,
                  },
                }}
                label="Get Promo"
                IconComponent={ArrowRightIcon}
                onClick={() => setNotificationIsOpen(true)}
              />
            </Box>
          </Grid> */}
        </Grid>
      )}
      <Notification
        open={notificationIsOpen}
        onClose={() => setNotificationIsOpen(false)}
        title="Promo code successfully entered"
        description="Enjoy savings with your newly added promo code in your cart!"
      />
    </Section>
  );
};

export default VehicleTrackersSection;
